import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { BsTelephoneInboundFill, BsTelephoneOutbound } from "react-icons/bs";
import Lead from "../../../shared/Lead";

const AbandonedCall = ({ task }) => {
  return (
    <>
      <Row className="flex">
        <Col sm={4} md={3} className="bg-grey br">
          <Button id="btn outline" disabled={true}>
            {"Edit Task"}
          </Button>
          <br />
          <br />
        </Col>

        <Col sm={8} md={9} className="task-cols pad20">
          <Lead message={task.label} />
          <div className="mt10">
            <BsTelephoneOutbound className="phone-number-icon" />
            <b>From</b>
            {task.phone_call.from}
            {"   "}
            <BsTelephoneInboundFill className="phone-number-icon ml20" />
            <b>To</b>
            {task.phone_call.to}
          </div>
          <hr />
          <figure className="mt20 pad20">
            <figcaption>Abandoned Call from {task.phone_call.from}</figcaption>
          </figure>

          <div className="bottom">
            Created at:{" "}
            <b>
              {new Date(task.created_at).toLocaleString([], {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
              })}
            </b>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default AbandonedCall;
